export const INITIAL_QUIZ_PAGE_MODEL = {
    backgroundUrl: '',
    backgroundFixed: true,
    showSubstrate: true,
    showTitle: true,
    titleRu: "Квиз",
    titleEn: "Quiz",
};
